import * as React from 'react';

function SvgReco(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.831 5.541c1.125-.28 2.355-.26 3.596.07a9.432 9.432 0 013.047 1.459 9.8 9.8 0 01-1.376 1.55 10.671 10.671 0 01-2.29 1.602 8.94 8.94 0 01-2.467.866c-.808.148-1.552.146-2.19.012a.602.602 0 00-.727.525.72.72 0 00.55.793c.827.175 1.735.167 2.667-.004a10.119 10.119 0 002.796-.979 11.85 11.85 0 002.544-1.779 10.71 10.71 0 001.925-2.321.67.67 0 00.084-.462.732.732 0 00-.263-.463c-1.237-1-2.625-1.722-4.058-2.103-1.433-.38-2.875-.41-4.21-.076A7.186 7.186 0 009.985 6.24c-.945.987-1.617 2.243-1.966 3.662a.723.723 0 00.466.846.6.6 0 00.782-.435c.299-1.211.867-2.267 1.657-3.092a6.01 6.01 0 012.906-1.68z"
        fill="currentColor"
      />
      <path
        d="M14.908 8.733c.354-.01.616-.32.583-.691-.032-.372-.345-.665-.7-.655-.748.022-1.51.229-2.239.591-.73.363-1.419.879-2.03 1.51a8.974 8.974 0 00-1.544 2.173 8.644 8.644 0 00-.83 2.513.721.721 0 00.529.808c.35.085.682-.14.741-.502a7.341 7.341 0 01.706-2.13 7.75 7.75 0 011.332-1.876A6.337 6.337 0 0113.164 9.2c.6-.298 1.194-.452 1.744-.467z"
        fill="currentColor"
      />
      <path
        d="M6.542 5.844a1 1 0 011.213 1.59A7 7 0 1019 12.988a1 1 0 012-.003A9 9 0 116.542 5.844z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgReco;
